import { Injectable, ComponentRef, ComponentFactoryResolver, ViewContainerRef, ComponentFactory, Type } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DomService {

  constructor() {
  }

  addComponentToDOM(componentType: any, container: ViewContainerRef) {
    return container.createComponent(componentType) as ComponentRef<any>;
  }

  addComponentToDOMAtIndex(componentType: any, container: ViewContainerRef, index: any) {
    return container.createComponent(componentType,{index: 1}) as ComponentRef<any>;
  }

}
